import { zodResolver } from "@hookform/resolvers/zod";
import { AlertDialog } from "../../common/AlertDailog";
import DynamicForm from "../../common/DynamicForm";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { assignComponentSchema } from "./uiConfigSchema";

const AssignComponentForm = (props: any) => {
  const {
    assignComponentPopup,
    setAssignComponentPopup,
    components,
    setRows,
    rows,
  } = props;

  const listOfComponents = [
    ...components.listComponent,
    ...components.detailsComponent,
  ].map((item, index) => item.component_name);

  const fields: any = [
    {
      name: "components",
      label: "Select Component",
      size: 6,
      required: true,
      inputType: "autocomplete",
      multiple: true,
      options: listOfComponents,
    },
    {
      name: "medium_screen_size",
      label: "Medium Screen Size",
      inputType: "number",
      size: 6,
      required: true,
      type: "tel",
    },
    {
      name: "small_screen_size",
      label: "Small Screen Size",
      type: "tel",
      inputType: "number",
      size: 6,
      required: true,
    },
  ];

  type FormValues = z.infer<typeof assignComponentSchema>;

  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
  } = useForm<FormValues>({
    resolver: zodResolver(assignComponentSchema),
    defaultValues: {},
  });

  const handleSave = (data: any) => {
    const temp = [data, ...rows].map((item) => {
      return { ...item, id: crypto.randomUUID() };
    });

    setRows(temp);
    setAssignComponentPopup(false);
  };

  const onInvalid = (data: any) => {
    console.debug(data);
  };

  return (
    <AlertDialog
      open={assignComponentPopup}
      handleClose={() => setAssignComponentPopup(false)}
      handleConfirm={handleSubmit(handleSave, onInvalid)}
      maxWidth="md"
      title="Assign Component"
    >
      <DynamicForm
        fieldsJson={fields}
        register={register}
        control={control}
        errors={errors}
      />
    </AlertDialog>
  );
};

export default AssignComponentForm;
